<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div v-if="!isTokenExpired">
      <div class="columns">
        <div class="column is-2">
          <div class="control">
            <label class="label is-small">Employee ID</label>
            <div class="field">
              <input v-model="timeSheet.employeeId" class="input is-small" readonly />
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label is-small">Name</label>
            <div class="field">
              <input v-model="timeSheet.employeeName" class="input is-small" readonly />
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label is-small">Period</label>
            <div class="field">
              <input v-model="timeSheet.datePeriod" class="input is-small" readonly />
            </div>
          </div>
        </div>
      </div>
      <button :class="buttonSave" @click="sendAdjustmentRequest">Send Adjustment Request</button><br /><br />
      <div style="clear:both" />
      <b-table :data="timeSheet.timeSheetForPrinting" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true">
        <template slot-scope="item">
          <b-table-column field="dateLog" class="table-column-content-is-small" label="Date Log">
            {{item.row.dateLog}}
          </b-table-column>
          <b-table-column field="day" class="table-column-content-is-small" label="Day">
            {{item.row.day}}
          </b-table-column>
          <b-table-column field="checkIn" class="table-column-content-is-small" label="Check In">
            {{item.row.checkIn}}
          </b-table-column>
          <b-table-column field="checkOut" class="table-column-content-is-small" label="Check Out">
            {{item.row.checkOut}}
          </b-table-column>
          <b-table-column field="adjustment" class="table-column-content-is-small" label="Adjustment Note">
            {{item.row.adjustmentNote}}
          </b-table-column>
          <b-table-column field="" class="table-column-content-is-small" label="">
            <button class="button is-info is-small" @click="openAddNoteModal(item.row)">Add Note</button>
            &nbsp;
            <button class="button is-danger is-small" @click="deleteNoteByDateLog(item.row)">Remove Note</button>
          </b-table-column>
        </template>
      </b-table>

      <div class="modal is-active" v-show="showAddNoteModal">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Add Note for Date Log ({{this.selectedInfo.dateLog}})</p>
            <button class="delete" @click="cancel" aria-label="close"></button>
          </header>
          <section class="modal-card-body">
            <!-- Content ... -->
            <div class="columns">
              <div class="column is-12">
                <div class="control">
                  <label class="label is-small">Adjustment Note</label>
                  <div class="field">
                    <textarea class="input is-small" v-model="adjustmentNote" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot" style="justify-content:flex-end">
            <button class="button is-small is-info" @click="addNoteToTheList()">Add</button>
            <button class="button  is-small" @click="cancel">No</button>
          </footer>
        </div>
      </div>
    </div>
    <div v-else>
      <center>
        <h3 class="title is-3">Token already expired. Please request for new link</h3>
      </center>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import VueJWT from 'vuejs-jwt'
import AppToast from '../../frontend/appToast'
import AppButton from '../../frontend/appButton'

Vue.use(VueJWT)

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    timeSheet: {
      timeSheetForPrinting: []
    },
    showAddNoteModal: false,
    selectedInfo: {},
    adjustmentNote: '',
    isTokenExpired: false,
    buttonSave: appButton.isLoadingSuccess(false),
    isLoading: false
  }),
  created() {
    var token = this.$route.params.token
    if (token) {
      var decodedToken = Vue.$jwt.decode(token)
      if (decodedToken) {
        if (decodedToken.exp < new Date().getTime() / 1000) {
          alert('Link expired. Please request new link from the HR')
          this.isTokenExpired = true
        } else {
          this.getTimeSheets(token)
        }
      }
    }
  },
  methods: {
    sendAdjustmentRequest() {
      this.buttonSave = appButton.isLoadingSuccess(true)
      const timeSheet = {
        employeeId: this.timeSheet.employeeId,
        datePeriod: this.timeSheet.datePeriod,
        employeeName: this.timeSheet.employeeName,
        timeSheetForModificationDetails: this.timeSheet.timeSheetForPrinting
      }
      axios
        .post(`api/guestemployeetimesheets/`, timeSheet)
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => console.log(error)).then(()=>{
          this.buttonSave = appButton.isLoadingSuccess(false)
        })
    },
    getTimeSheets(token) {
      this.isLoading = true
      axios
        .get(`api/guestemployeetimesheets/get-timesheet?token=${token}`)
        .then(response => {
          this.timeSheet = response.data
        })
        .catch(error => {
          appToast.danger(
            'Something went wrong. Failed to get the timesheet record'
          )
          console.log(error)
        }).then(()=>{
          this.isLoading = false
        })
    },
    openAddNoteModal(info) {
      this.showAddNoteModal = true
      this.selectedInfo = info
    },
    addNoteToTheList() {
      var index = _.findIndex(this.timeSheet.timeSheetForPrinting, {
        dateLog: this.selectedInfo.dateLog
      })

      this.timeSheet.timeSheetForPrinting.splice(index, 1, {
        dateLog: this.selectedInfo.dateLog,
        day: this.selectedInfo.day,
        checkIn: this.selectedInfo.checkIn,
        checkOut: this.selectedInfo.checkOut,
        adjustmentNote: this.adjustmentNote
      })

      this.defaultAddNoteModal()
    },
    deleteNoteByDateLog(info){
      this.selectedInfo = info
      var index = _.findIndex(this.timeSheet.timeSheetForPrinting, {
        dateLog: this.selectedInfo.dateLog
      })

      this.timeSheet.timeSheetForPrinting.splice(index, 1, {
        dateLog: this.selectedInfo.dateLog,
        day: this.selectedInfo.day,
        checkIn: this.selectedInfo.checkIn,
        checkOut: this.selectedInfo.checkOut,
        adjustmentNote: this.adjustmentNote
      })

      this.selectedInfo = {}
    },
    defaultAddNoteModal() {
      this.adjustmentNote = ''
      this.showAddNoteModal = false
      this.selectedInfo = {}
    },
    cancel() {
      this.showAddNoteModal = false
    }
  }
}
</script>
